export default {
  usedTokenTitle: 'Oh no, parece que esta invitación ya está en uso.',
  usedTokenMessage: 'Tu link de invitación ya ha sido utilizado por alguien más. Puedes pedir una nueva invitación a los directivos. Si te parece que hay un problema contáctate con Kimple para solucionarlo.',
  expiredTokenTitle: 'Oops, esta invitación a Kimple ya ha expirado.',
  expiredTokenMessageStart: 'Tu link de invitación se ha vencido porque no lo has usado. Las invitaciones duran dos semanas y se pueden usar una sola vez. Puedes',
  expiredTokenMessageRequest: 'pedir que te inviten nuevamente',
  expiredTokenMessageEnd: 'a la plataforma para poder registrarte o puedes comunicarte con Kimple.',
  requestInvitationResendError: 'Ha ocurrido un error, por favor intente nuevamente',
  renewInvitationSuccessTitle: '¡Solicitud enviada!',
  renewConfirmModal: {
    title: 'Solicitar nueva invitación',
    message: '¿Estás seguro que deseas solicitar una nueva invitación?',
    rightLabel: 'Solicitar'
  },
  contact: 'Contactarte con Kimple',
  altImage: 'Error en token',
  successfulActivation: 'Tu cuenta se activó correctamente',
  ExpiredToken: 'Oops, esta activación a Kimple no es válida',
  UsedToken: 'Tu cuenta ya fue activada',
  InvalidToken: 'Oops, esta activación a Kimple no es válida',
  exploreKimple: 'Explora Kimple',
  inconvenient: '¿Tienes algún inconveniente?',
  contactKimple: 'Contáctate con Kimple'
}

export const en = {
  usedTokenTitle: 'Oh no, this invite has already been used.',
  usedTokenMessage: 'Your invite link has been used by someone else. You can ask your managers for a new invite. If you think there\'s a problem, get in touch with Kimple to solve it.',
  expiredTokenTitle: 'Ops, this Kimple invite has expired.',
  expiredTokenMessageStart: 'Your invite link has expired because you didn\'t use it. Invites last two weeks and can be used only once. You can',
  expiredTokenMessageRequest: 'ask for a new invite',
  expiredTokenMessageEnd: 'to the platform to sign up or you can get in touch with Kimple.',
  contact: 'Get in touch with Kimple',
  altImage: 'Token error',
  successfulActivation: 'Your account was successfully activated',
  ExpiredToken: 'Oops this activation to Kimple is invalid.',
  UsedToken: 'Your account has been activated',
  InvalidToken: 'Oops this activation to Kimple is invalid.',
  exploreKimple: 'Explore Kimple',
  inconvenient: 'Issues or concerns?',
  contactKimple: 'Contact Kimple'
}

export const ca = {
  usedTokenTitle: 'Vaja, sembla que aquesta invitació ja s\'està fent servir.',
  usedTokenMessage: 'Algú ja ha fet servir el teu enllaç d\'invitació. Pots demanar una altra invitació als directius. Si creus que hi ha hagut un problema contacta amb Kimple per solucionar-ho.',
  expiredTokenTitle: 'Vaja, aquesta invitació a Kimple ja s\'ha caducat.',
  expiredTokenMessageStart: 'El teu enllaç d\'invitació s\'ha caducat perquè no l\'has fet servir. Les invitacions tenen una durada de dues setmanes i només es poden fer servir una vegada. Pots',
  expiredTokenMessageRequest: 'demanar que et convidin una altra vegada',
  expiredTokenMessageEnd: 'a la plataforma per poder registrar-te o pots posar-te en contacte amb Kimple.',
  contact: 'Contacta amb Kimple',
  altImage: 'Error al criptovalor',
  successfulActivation: 'El teu compte s\'ha activat correctament',
  ExpiredToken: 'Vaja, aquesta activació no és vàlida a Kimple',
  UsedToken: 'Ja s\'ha activat el teu compte',
  InvalidToken: 'Vaja, aquesta activació no és vàlida a Kimple',
  exploreKimple: 'Explora Kimple',
  inconvenient: 'Has tingut algun problema?',
  contactKimple: 'Posa\'t en contacte amb Kimple'
}
